import { 
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData, 
    addDataFactory
} from "../../core/core";
import { IDashboardSharedViewModel } from "./viewModel";

/**
 * Sort asc
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    return ((a > b) ? -1 : ((a < b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardSharedViewModel) => vm.ses.name);
